/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_TitleInputs */

const en_a11y_statement_title = /** @type {(inputs: A11y_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibility Statement`)
};

const de_a11y_statement_title = /** @type {(inputs: A11y_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklärung zur Barrierefreiheit`)
};

const fr_a11y_statement_title = /** @type {(inputs: A11y_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declaration d'accessibilite`)
};

const es_a11y_statement_title = /** @type {(inputs: A11y_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declaracion de accesibilidad`)
};

const it_a11y_statement_title = /** @type {(inputs: A11y_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dichiarazione di accessibilita`)
};

const nl_a11y_statement_title = /** @type {(inputs: A11y_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegankelijkheidsverklaring`)
};

const pl_a11y_statement_title = /** @type {(inputs: A11y_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oswiadczenie o dostepnosci`)
};

const fi_a11y_statement_title = /** @type {(inputs: A11y_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutettavuuslausunto`)
};

const da_a11y_statement_title = /** @type {(inputs: A11y_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilgaengelighedserklaering`)
};

const sv_a11y_statement_title = /** @type {(inputs: A11y_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillganglighetsforklaring`)
};

/**
* | output |
* | --- |
* | "Accessibility Statement" |
*
* @param {A11y_Statement_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_title = /** @type {((inputs?: A11y_Statement_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_title(inputs)
	if (locale === "fr") return fr_a11y_statement_title(inputs)
	if (locale === "es") return es_a11y_statement_title(inputs)
	if (locale === "it") return it_a11y_statement_title(inputs)
	if (locale === "nl") return nl_a11y_statement_title(inputs)
	if (locale === "pl") return pl_a11y_statement_title(inputs)
	if (locale === "fi") return fi_a11y_statement_title(inputs)
	if (locale === "da") return da_a11y_statement_title(inputs)
	if (locale === "sv") return sv_a11y_statement_title(inputs)
	return en_a11y_statement_title(inputs)
});